import accordbank from './assets/accordbank.webp';
import altbank from './assets/altbank.webp';
import bank3_4 from './assets/bank3_4.webp';
import bankcreditdnipro from './assets/bankcreditdnipro.webp';
import creditagricole from './assets/creditagricole.webp';
import globus from './assets/globusplus.webp';
import grant from './assets/grant.webp';
import izibank from './assets/izibank.webp';
import kredobank from './assets/kredobank.webp';
import monobank from './assets/monobank.webp';
import mtbbank from './assets/mtbbank.webp';
import obank from './assets/obank.webp';
import otpbank from './assets/otpbank.webp';
import pravexbank from './assets/pravexbank.webp';
import privat24 from './assets/privat24.webp';
import pumb from './assets/pumb.png';
import radabank from './assets/radabank.webp';
import raiffiesenbak from './assets/raiffiesenbank.webp';
import sensebank from './assets/sensebank.webp';
import ugb from './assets/ugb.webp';
import ukrsibbank from './assets/ukrsibbank.webp';
import unexbank from './assets/unexbank.webp';
import vstbank from './assets/vstbank.webp';
import winbank from './assets/winbank.webp';
import abank from './assets/abank.webp';

export default [
  {
    logo: monobank,
    label: 'Monobank',
    code: 'monobank',
    deeplink: {
      android: 'com.ftband.mono',
      ios: 'mono',
    },
  },
  {
    logo: privat24,
    label: 'Приват24',
    code: 'privat24',
    deeplink: {
      android: 'ua.privatbank.ap24',
      ios: 'privat24',
    },
  },
  {
    logo: abank,
    label: 'А-Банк',
    code: 'abank',
    deeplink: {
      android: 'ua.com.abank',
      ios: 'abank24',
    },
  },
  {
    logo: pumb,
    label: 'ПУМБ',
    code: 'pumb',
    deeplink: {
      android: 'com.fuib.android.spot.online',
      ios: 'pumb-online.app',
    },
  },
  {
    logo: sensebank,
    label: 'Sense Bank',
    code: 'sensebank',
    deeplink: {
      android: 'ua.alfabank.mobile.android',
      ios: 'ua.alfabank.mobile.ios',
    },
  },
  {
    logo: ukrsibbank,
    label: 'Укрсіббанк',
    code: 'ukrsibbank',
    deeplink: {
      android: 'com.ukrsibbank.uso.android',
      ios: 'com.ukrsibbank.ukrsibonline.new',
    },
  },
  {
    logo: raiffiesenbak,
    label: 'Райффайзен Банк',
    code: 'raiffiesenbank',
    deeplink: {
      android: '',
      ios: 'myraif',
    },
  },
  {
    logo: ugb,
    label: 'Ukrgasbank',
    code: 'ukrgasbank',
    deeplink: {
      android: 'com.ugb.app',
      ios: 'ecobank',
    },
  },
  {
    logo: izibank,
    label: 'izibank',
    code: 'izibank',
    deeplink: {
      android: 'ua.izibank.app',
      ios: 'izibank',
    },
  },
  {
    logo: mtbbank,
    label: 'МТБ Банк',
    code: 'mtbbank',
    deeplink: {
      android: 'com.ua.mtb.bank',
      ios: 'mtb360',
    },
  },
  {
    logo: kredobank,
    label: 'KredoBank',
    code: 'kredobank',
    deeplink: {
      android: '',
      ios: '',
    },
  },
  {
    logo: creditagricole,
    label: 'Креді Агріколь Банк',
    code: 'creditagricole',
    deeplink: {
      android: 'ua.creditagricole.mobile.app',
      ios: '',
    },
  },
  {
    logo: otpbank,
    label: 'ОТП БАНК',
    code: 'otpbank',
    deeplink: {
      android: 'ua.otpbank.android',
      ios: 'otpbankua',
    },
  },
  {
    logo: accordbank,
    label: 'Аккордбанк',
    code: 'accordbank',
    deeplink: {
      android: '',
      ios: '',
    },
  },
  {
    logo: altbank,
    label: 'Altbank Private',
    code: 'altbank',
    deeplink: {
      android: 'by.st.alt.fiz',
      ios: '',
    },
  },
  {
    logo: bank3_4,
    label: 'Банк 3/4',
    code: 'bank3_4',
    deeplink: {
      android: '',
      ios: '',
    },
  },
  {
    logo: bankcreditdnipro,
    label: 'Банк Кредит Дніпро',
    code: 'bankcreditdnipro',
    deeplink: {
      android: 'com.creditdnepr.mb',
      ios: 'freebank',
    },
  },
  {
    logo: globus,
    label: 'Глобус Банк',
    code: 'globus',
    deeplink: {
      android: 'com.t18.bone.personal.globus',
      ios: 'globus',
    },
  },
  {
    logo: grant,
    label: 'Грант',
    code: 'grant',
    deeplink: {
      android: 'ua.grant.smart',
      ios: '',
    },
  },
  {
    logo: obank,
    label: 'Ідея Банк',
    code: 'ideabank',
    deeplink: {
      android: 'ua.ideabank.obank',
      ios: 'com.idea.obank',
    },
  },
  {
    logo: pravexbank,
    label: 'ПРАВЕКС БАНК',
    code: 'pravexbank',
    deeplink: {
      android: '',
      ios: 'fb181676614715502',
    },
  },
  {
    logo: radabank,
    label: 'РАДАБАНК',
    code: 'radabank',
    deeplink: {
      android: 'com.radabank.rb24',
      ios: 'radabank',
    },
  },
  {
    logo: unexbank,
    label: 'Unex Bank',
    code: 'unexbank',
    deeplink: {
      android: '',
      ios: '',
    },
  },
  {
    logo: vstbank,
    label: 'VST bank',
    code: 'vstbank',
    deeplink: {
      android: 'com.vstbank.mobile',
      ios: 'vstbank',
    },
  },
  {
    logo: winbank,
    label: 'Winbank Ukraine',
    code: 'winbank',
    deeplink: {
      android: 'ua.piraeusbank.mobile.app.pbu',
      ios: '',
    },
  },
];
